module.exports = __webpack_public_path__ + "img/12.b87e1979.png";